module.exports = __webpack_public_path__ + "static/media/ins8.dad0205e.jpg";